















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FileMenu from '@/components/files/FileMenu.vue';
import { Storage } from "aws-amplify";
import moment from "moment";
import { getFileType, getIcon } from "@/utils/FileUtils";
import { fileSaleSubscriptionService, SaleStatusUpdate, SaleStatusCallback } from "@/services/files/FileSaleSubscription";
import { FileSearchService } from "@/services/files/FileSearch";

@Component({
  components:{
    FileMenu,
  }
})
export default class FileCard extends Vue {
  @Prop()
  private file;
  @Prop()
  private position;
  @Prop()
  private select;
  @Prop()
  private mode;
  @Prop()
  private sharing;

  private fileSearchService = new FileSearchService();
  private attributes;

  private sheet = false;
  private show = false;
  private lines = 2;
  private detailLink = {};

  private id = '';
  private src = '';
  private title = ''
  private fileName = '';
  private datetimeOriginated = '';
  private byline = '';
  private share = false;
  private sale = false;
  private caution = false;
  private protect = false;
  private rating = 0;
  private caption ='';
  private instructions = '';
  private fileType = '';
  private imgHeight = "100%"
  private imgBackColor = "grey darken";
  private imgPosition ="center center"
  private imgClass = "";
  private isCoverFile = false;
  private saleStatus = "";
  private saleStatusCallback: SaleStatusCallback | null = null;
  private currentRequestId: string | null = null;  // 現在監視中のrequestIdを保持

  @Watch('file')
  private async onFileChanged(){
    this.setFile();
    // ファイルオブジェクト変更時は念のためsubscriptionをクリーンアップ
    this.stopWatchingSaleStatus();
  }

  private async created(){
    this.setFile();
  }

  private beforeDestroy() {
    // コールバックを解除
    this.stopWatchingSaleStatus();
  }

  /**
   * 外販送信ステータスの監視を開始
   * 外販送信実行時に呼び出される
   * @param requestId - 外販送信リクエストの一意ID
   */
  public startWatchingSaleStatus(requestId: string) {
    if (!this.file || !this.file.id) {
      return;
    }

    // 既存のrequestIdがある場合は先にクリーンアップ
    if (this.currentRequestId && this.currentRequestId !== requestId) {
      fileSaleSubscriptionService.unsubscribe(this.currentRequestId);
    }

    // 現在のrequestIdを保存
    this.currentRequestId = requestId;

    // コールバックを登録、callbackが呼び出されると最新情報を取得
    this.saleStatusCallback = async (data: SaleStatusUpdate) => {
      // 自分のファイルIDの更新のみ処理
      if (data.fileId === this.file.id) {
        // エラーステータスの場合はコールバックをリセットするだけ
        if (data.status === 'error') {
          this.saleStatusCallback = null;
          this.currentRequestId = null;
          return;
        }
        
        // 通常のステータス更新は再検索を実行
        await this.refreshFileData(data.fileId);
      }
    };

    // ユーザー情報を取得
    const user = this.$store.getters.user;
    const accountId = user?.attributes?.['custom:account_id'] || '';
    const userId = user?.attributes?.sub || '';
    
    fileSaleSubscriptionService.subscribe(requestId, this.file.id, accountId, userId, this.saleStatusCallback);
  }

  /**
   * 最新のファイル情報を取得して更新
   * OpenSearchの同期を待つため、数秒待機してから実行
   */
  private async refreshFileData(fileId: string) {
    try {
      // OpenSearchの同期を待つため3秒待機
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      const condition = {
        fileId: fileId
      };
      
      const result = await this.fileSearchService.searchFiles(condition, undefined, 0, 1);
      const items = result?.items;
      if (items && items.length > 0) {
        const updatedFile = items[0];
        
        // fileオブジェクトのsaleStatus関連プロパティを更新
        this.file.saleStatus = updatedFile.saleStatus;
        this.file.saleCount = updatedFile.saleCount;
        this.file.protect = updatedFile.protect;
        
        // 表示用のプロパティも更新
        this.saleStatus = updatedFile.saleStatus !== undefined && updatedFile.saleStatus !== null ? updatedFile.saleStatus : "";
        this.protect = updatedFile.protect && updatedFile.protect === 1 ? true : false;
        
        // 親コンポーネントに更新を通知（files配列も更新してもらう）
        this.$emit('file-updated', {
          fileId: fileId,
          saleStatus: updatedFile.saleStatus,
          saleCount: updatedFile.saleCount,
          protect: updatedFile.protect
        });
        
        // 成功/失敗時はsubscriptionが自動停止されるため、コールバックをリセット
        if (updatedFile.saleStatus === 'success' || updatedFile.saleStatus === 'failure') {
          this.saleStatusCallback = null;
          this.currentRequestId = null;
        }
      } else {
        console.warn(`File not found in OpenSearch (fileId: ${fileId})`);
        this.stopWatchingSaleStatus();
      }
    } catch (error) {
      console.error('Failed to refresh file from OpenSearch:', error);
      // OpenSearch取得エラー時はsubscriptionを停止
      this.stopWatchingSaleStatus();
    }
  }

  /**
   * 外販送信ステータスの監視を停止
   */
  private stopWatchingSaleStatus() {
    if (this.currentRequestId) {
      fileSaleSubscriptionService.unsubscribe(this.currentRequestId);
    }
    this.saleStatusCallback = null;
    this.currentRequestId = null;
  }

  private async setFile(){
    if(this.$store.getters.user && this.$store.getters.user.attributes){
      this.attributes = this.$store.getters.user.attributes;
    }

    this.src = "";
    if(this.file){
      this.fileType = this.file.type && this.file.extension ? getFileType(this.file.extension, this.file.type) : '';
      
      if(this.fileType !== "image" && this.fileType !== "video"){
        this.imgHeight = "60%";
        this.imgBackColor = "";
        this.imgClass = "img-icon"
        this.src = getIcon(this.fileType);
      }

      this.title = this.file.title ? this.file.title : '';
      this.fileName = this.file.fileName ? this.file.fileName : '';
      
      const meta = this.file.meta ? JSON.parse(this.file.meta) : undefined;
      this.datetimeOriginated = '不明';
      if(meta && meta.datetimeOriginated){
        if((meta.originatedStatus === 0 || meta.originatedStatus === 1) && moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSS', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSS', true).format('YYYY年MM月DD日 HH:mm:ss.SSS');
        }else if(meta.originatedStatus === 1 && moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss', true).format('YYYY年MM月DD日 HH:mm:ss');
        }else if((meta.originatedStatus === 0 || meta.originatedStatus === 1) && moment(meta.datetimeOriginated, 'YYYY-MM-DD', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY-MM-DD', true).format('YYYY年MM月DD日');
        }else if(meta.originatedStatus === 2 && moment(meta.datetimeOriginated, 'YYYY-MM', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY-MM', true).format('YYYY年MM月');
        }else if(meta.originatedStatus === 2 && moment(meta.datetimeOriginated, 'YYYY', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY', true).format('YYYY年');
        }else if((meta.originatedStatus === null || meta.originatedStatus === undefined) && moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSS', true).isValid()){
          this.datetimeOriginated = moment(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSS', true).format('YYYY年MM月DD日 HH:mm:ss.SSS');
        // Timezoneがある場合
        }else if((meta.originatedStatus === 0 || meta.originatedStatus === 1) && moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid()){
          this.datetimeOriginated = moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).format('YYYY年MM月DD日 HH:mm:ss.SSSZ');
        }else if((meta.originatedStatus === 0 || meta.originatedStatus === 1) && moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()){
          this.datetimeOriginated = moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ssZ', true).format('YYYY年MM月DD日 HH:mm:ssZ');
        }else if((meta.originatedStatus === null || meta.originatedStatus === undefined) && moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid()){
          this.datetimeOriginated = moment.parseZone(meta.datetimeOriginated, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).format('YYYY年MM月DD日 HH:mm:ss.SSSZ');
        }
      }else if(meta && meta.originatedStatus === 3 && meta.aroundYearOriginated && moment(meta.aroundYearOriginated, 'YYYY', true).isValid()){
        this.datetimeOriginated = moment(meta.aroundYearOriginated, 'YYYY', true).format('YYYY年頃');
      }else if(meta && meta.originatedStatus === 4 && meta.ageOriginated && moment(meta.ageOriginated, 'YYYY', true).isValid()){
        this.datetimeOriginated = moment(meta.ageOriginated, 'YYYY', true).format('YYYY年代');
      }
      
      this.byline = meta.byline ? meta.byline : '';
      const thumbnailUri = meta && meta.thumbnailUri ? meta.thumbnailUri.split('/') : [];
      if((this.fileType === "image" || this.fileType === "video") && thumbnailUri.length > 0){
        this.src = (await Storage.get(`${thumbnailUri[4]}/${thumbnailUri[5]}/${thumbnailUri[6]}/${thumbnailUri[7]}`, {download: false, expires: 300, contentType: 'image/jpeg'})).toString();
      } else if(this.fileType === "video" && thumbnailUri.length <= 0){
        this.imgHeight = "60%";
        this.imgBackColor = "";
        this.imgClass = "img-icon"
        this.src = getIcon(this.fileType);
      }
      
      const customItems = this.file.customItems ? JSON.parse(this.file.customItems) : undefined;
      this.share = customItems && customItems.share === 0 ? true : false;
      this.sale = customItems && customItems.sale === 0 ? true : false;
      this.caution = this.file.caution && this.file.caution === 1 ? true : false;
      this.protect = this.file.protect && this.file.protect === 1 ? true : false;
      this.rating = this.file.rating ? this.file.rating : 0;

      this.saleStatus = this.file.saleStatus !== undefined ? this.file.saleStatus : "";

      this.caption = this.file.caption ? this.file.caption : '';
      this.instructions = this.file.instructions ? this.file.instructions : '';

      if(this.mode === 'share' && this.sharing){
        this.detailLink = { name: 'ShareDetail', query: { q: this.sharing.id, position: this.position }};
      }else{
        if(this.file.group && this.file.group.coverFileId && this.file.group.coverFileId === this.file.id){
          this.isCoverFile = true;
        }else{
          this.isCoverFile = false;
        }
        this.detailLink = { name: 'FileDetail', params: { position: this.position } };
      }
    }
  }

  private onChangeFileMenuSheet(value){
    this.sheet = value;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChangeFileMenuResult(isSearch: boolean, postProcess: string){
    if(isSearch){
      this.$emit('file-card-result', isSearch);
    }
  }

  private onSaleStarted(payload: { fileId: string; requestId: string }){
    // 外販送信が開始されたら、このファイルのステータス監視を開始
    if (payload.fileId === this.file.id) {
      // 既に同じrequestIdで監視中なら何もしない（重複防止）
      if (this.currentRequestId === payload.requestId) {
        return;
      }
      this.startWatchingSaleStatus(payload.requestId);
    }
  }
}
